<template>
  <v-flex md12 xs11>
    <material-card
      :title="$t('medicine-list-title')"
      class="mx-4"
      color="primary"
    >
      <v-card-title>
        <v-text-field
          v-model="medicinesTable.searchTerm"
          :label="$t('search')"
          md8
          single-line
          hide-details
        />
      </v-card-title>

      <v-data-table
        :rows-per-page-text="$t('rows-per-page-text')"
        :rows-per-page-items="globalrowsPerPageItems"
        :search="medicinesTable.searchTerm"
        :headers="headers"
        :items="dataMedicines"
        :no-data-text="$t('no-data-available')"
        item-key="name"
      >
        <template slot="headerCell" slot-scope="{ header }">
          <span
            class="subheading font-weight-light text-primary"
            v-text="header.text"
          />
        </template>
        <template v-slot:items="props">
          <tr
            :class="{
              applicableMedicine: props.item.isApplicable,
              featuredMedicine: props.item.isFeatured,
              watchedMedicine: props.item.isWatched,
            }"
          >
            <td class="text-xs-left">
              <v-checkbox v-model="props.item.check" disabled />
            </td>
            <td class="text-xs-left">{{ props.item.fullname }}</td>
            <td class="text-xs-left">{{ props.item.document }}</td>
            <td class="text-xs-left">{{ props.item.orderCode }}</td>
            <td class="text-xs-left">{{ props.item.plu }}</td>
            <td class="text-xs-left">{{ props.item.description }}</td>
            <td class="text-xs-center">{{ props.item.count }}</td>
            <!-- <td class="text-xs-center">{{ props.item.providerName }}</td> -->
            <td class="text-xs-center">
              {{
                props.item.initialProvider
                  ? props.item.initialProvider.name
                  : props.item.providerName
              }}
            </td>
            <td class="text-xs-center">
              {{ props.item.scaleFee | formatMoney }}
            </td>
            <td class="text-xs-center">{{ props.item.deliveryNumber }}</td>
            <td class="text-xs-center">
              {{ $t("order-statuses." + props.item.status) }}
            </td>
            <td>
              <v-select
                v-model="props.item.typeCancelOrders"
                :items="typeCancelOrders"
                :disabled="
                  props.item.status &&
                  props.item.status != 'NO_STATUS' &&
                  props.item.status != 'SCHEDULED'
                "
                :label="$t('selectMotiv')"
                :clearable="true"
                class="input-group--focused"
                item-value="text"
                persistent-hint
                @change="changeSelectedMedicine(props.item)"
              />
              <v-flex
                v-if="props.item.typeCancelOrders === 'Previamente Entregado'"
              >
                <v-menu
                  v-model="menuPreviewDelivered"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="props.item.datePreviewDelivery"
                      label="Fecha Entregado"
                      readonly
                      :disabled="
                        props.item.status &&
                        props.item.status != 'NO_STATUS' &&
                        props.item.status != 'SCHEDULED'
                      "
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-if="props.item.index === select"
                    v-model="props.item.datePreviewDelivery"
                    :disabled="
                      props.item.status &&
                      props.item.status != 'NO_STATUS' &&
                      props.item.status != 'SCHEDULED'
                    "
                    :locale="$t('locale')"
                    :max="new Date().toISOString().slice(0, 10)"
                    header-color="primary"
                    @input="menuPreviewDelivered = false"
                    @change="changeSelectedMedicine(props.item)"
                  />
                </v-menu>
              </v-flex>
            </td>
          </tr>
        </template>
      </v-data-table>
    </material-card>
  </v-flex>
</template>

<style>
.theme--light.v-table tbody tr.applicableMedicine,
.theme--light.v-table tbody tr.applicableMedicine:hover {
  background-color: #f7f38bfa !important;
}

.theme--light.v-table tbody tr.featuredMedicine,
.theme--light.v-table tbody tr.featuredMedicine:hover {
  background-color: #ffa8c6 !important;
}
.theme--light.v-table tbody tr.watchedMedicine,
.theme--light.v-table tbody tr.watchedMedicine:hover {
  background-color: #b3e5fc !important;
}
</style>

<script>
import i18n from "../i18n/index";

export default {
  components: {},
  props: {
    dataMedicines: {
      type: Array,
      default: () => [],
    },
    deleteOrder: {
      type: Function,
      default: () => {},
    },
    order: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    index: null,
    dialogs: false,
    select: null,
    rules: [(value) => !!value || i18n.t("field-required")],
    medicinesTable: {
      searchItems: 0,
      searchTerm: "",
    },
    selectedMedicine: {},
    selected: "",
    datePreviewDelivery: "",
    menuPreviewDelivered: false,
    rowsPerPageItems: [5, 10, 15, 20],
    peopleSingleSelections: {},
    headers: [
      {
        sortable: false,
        text: "",
        align: "center",
        width: "10px",
      },
      {
        sortable: false,
        text: i18n.t("headers.patient"),
        value: "fullname",
        align: "left",
      },
      {
        sortable: false,
        text: i18n.t("headers.document"),
        value: "document",
        align: "left",
      },
      {
        sortable: false,
        text: i18n.t("headers.order-detail-number"),
        value: "orderCode",
        align: "left",
      },
      {
        sortable: false,
        text: i18n.t("headers.plu"),
        value: "plu",
        align: "left",
      },
      {
        sortable: false,
        text: i18n.t("headers.description"),
        value: "description",
        align: "left",
      },
      {
        sortable: false,
        text: i18n.t("headers.qty"),
        value: "count",
        align: "left",
      },
      {
        sortable: false,
        text: i18n.t("headers.provider"),
        value: "initialProvider",
        align: "left",
      },
      {
        sortable: false,
        text: i18n.t("headers.ssfee"),
        value: "scaleFee",
        align: "left",
      },
      {
        sortable: false,
        text: i18n.t("headers.nro-delivery"),
        value: "deliveryNumber",
        align: "left",
      },
      {
        sortable: false,
        text: i18n.t("headers.status"),
        value: "status",
        align: "left",
      },
      {
        sortable: false,
        text: i18n.t("headers.cancel_medicine"),
        value: "cancel_medicine",
        align: "left",
      },
    ],
    peopleSingleSelections: {},
    items: [],

    typeCancelOrders: [
      "Orden Anulada",
      "Orden vencida",
      "Previamente Entregado",
      "Solicitud del paciente",
      "Duplicidad",
      "El medicamento debe ser reclamado en Farmacia",
      "Dirección Errada",
      "Tutela",
      "Zona sin cobertura",
    ],
  }),
  methods: {
    medicineDate(val) {
      return new Date(val).getDay() <= val;
    },
    changeSelectedMedicine(value) {
      this.index = this.dataMedicines.findIndex(
        (item) => item.index == value.index
      );
      value["index"] = this.index;
      //console.log("this.index", this.index);
      this.select = this.index;
      //console.log("this.select", this.select);
      let list = [];
      if (value.typeCancelOrders === undefined) {
        // value.check = true;
        this.dataMedicines.forEach((e) => {
          if (e.orderCode === value.orderCode) {
            e.check = true;
            e.typeCancelOrders = "";
            e.datePreviewDelivery = "";
          }
          list.push({
            orderCode: e.orderCode,
            typeCancelOrders: e.typeCancelOrders,
            datePreviewDelivery: e.datePreviewDelivery,
          });
        });
        this.deleteOrder(list);
        return;
      }
      let text = value.typeCancelOrders;
      let fecha = value.datePreviewDelivery;
      this.dataMedicines.forEach((e) => {
        if (e.orderCode === value.orderCode) {
          e.check = false;
          e.datePreviewDelivery = value.datePreviewDelivery;
          // console.log(e.datePreviewDelivery)
          if (text !== e.typeCancelOrders) {
            switch (text) {
              case "Orden Anulada":
                e.typeCancelOrders = this.typeCancelOrders[0];
                break;
              case "Orden vencida":
                e.typeCancelOrders = this.typeCancelOrders[1];
                break;
              case "Previamente Entregado":
                e.typeCancelOrders = this.typeCancelOrders[2];
                break;
              case "Solicitud del paciente":
                e.typeCancelOrders = this.typeCancelOrders[3];
                break;
              case "Duplicidad":
                e.typeCancelOrders = this.typeCancelOrders[4];
                break;
              case "El medicamento debe ser reclamado en Farmacia":
                e.typeCancelOrders = this.typeCancelOrders[5];
                break;
              case "Dirección Errada":
                e.typeCancelOrders = this.typeCancelOrders[6];
                break;
              case "Tutela":
                e.typeCancelOrders = this.typeCancelOrders[7];
                break;
              case "Zona sin cobertura":
                e.typeCancelOrders = this.typeCancelOrders[8];
                break;
            }
          }
          list.push({
            orderCode: e.orderCode,
            typeCancelOrders: e.typeCancelOrders,
            datePreviewDelivery: e.datePreviewDelivery,
          });
        }
      });
      this.deleteOrder(list);
    },
    closeDialog() {
      this.selectedMedicine.typeCancelOrders = this.selected;
      this.selectedMedicine.datePreviewDelivery = this.datePreviewDelivery;

      this.deleteOrder(this.selectedMedicine);
      this.dialogs = false;
    },
    openModal(data) {
      this.dialogs = true;
      this.selectedMedicine = data;
      this.getSelectedMedince(this.selectedMedicine);
    },
    getSelectedMedince(data) {
      if (
        data.isApplicable === true ||
        data.isWatched === true ||
        data.isFeatured === true
      ) {
        this.selected = "El medicamento debe ser reclamado en Farmacia";
      } else {
        this.selected = "";
      }
    },
  },
};
</script>
